<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section v-if="packagesData.length" class="promotions main-content rooms background-light">
			<packages :items="packagesData" />
		</section>

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();
useRemoveGifty();

const { data: packagesData } = await useWebsiteFetch('meetingpackages', {
	query: { language: locale.value },
	key: `${locale.value}/meetingpackages`,
});
</script>

<style lang="scss" scoped>
.packages-section .block-item {
	width: 32%;
}

@media (max-width: 920px) {
	.packages-section .block-item {
		width: 48%;
	}
}

@media (max-width: 680px) {
	.packages-section .block-item {
		width: 100%;
	}
}
</style>
